import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20fbb25a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=20fbb25a&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=20fbb25a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fbb25a",
  null
  
)

export default component.exports